var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.bool)?_c('i',{staticClass:"fi-check",class:{'true': _vm.color},attrs:{"title":_vm.title}}):_c('i',{staticClass:"fi-x",class:{'false': _vm.color},attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }